var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWalIconActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none",
  viewBox: "0 0 13 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.5 0A6.5 6.5 0 1 0 13 6.5 6.507 6.507 0 0 0 6.5 0m4.898 4H9.169a8.5 8.5 0 0 0-1.393-2.85A5.52 5.52 0 0 1 11.398 4M12 6.5c0 .507-.07 1.012-.208 1.5H9.385a9.8 9.8 0 0 0 0-3h2.407c.138.488.208.993.208 1.5M6.5 1.188A7.2 7.2 0 0 1 8.125 4h-3.25A7.2 7.2 0 0 1 6.5 1.188M4.875 9h3.25A7.2 7.2 0 0 1 6.5 11.813 7.2 7.2 0 0 1 4.875 9m-.244-1a8.8 8.8 0 0 1 0-3h3.743a8.8 8.8 0 0 1 0 3zm3.147 3.85A8.5 8.5 0 0 0 9.172 9H11.4a5.52 5.52 0 0 1-3.625 2.85z"
})));
export { SvgWalIconActive as ReactComponent };
export default __webpack_public_path__ + "18685ee7583e95a2384ac9500746271e.svg";